import { ConditionGroup, FieldTemplate } from 'api/models/FieldTemplate';
import ConditionRow from './ConditionRow';
import LogicalOperators from './LogicalOperators';
import { FormTemplateType } from 'api/models';
import { produce } from 'immer';
import { set } from 'object-path';
import { Box } from '@mui/system';

interface ConditionRendererProps {
  rootGroup: ConditionGroup;
  group: ConditionGroup;
  path: string;
  onAddCondition: (path: string) => void;
  onChange: (conditionGroup: ConditionGroup | undefined) => void;
  fieldTemplates?: FieldTemplate[];
  patientFields?: FieldTemplate[];
  formTemplateTypes?: FormTemplateType[];
  disabled?: boolean;
}
export default function ConditionRenderer({
  rootGroup,
  group,
  path,
  onAddCondition,
  onChange,
  fieldTemplates,
  patientFields,
  formTemplateTypes,
  disabled,
}: ConditionRendererProps) {
  const { conditions } = group;

  return (
    <>
      {conditions.map((condition, index) => {
        if ('conditions' in condition) {
          return (
            <Box key={`${path}.conditions[${index}]`}>
              <ConditionRenderer
                path={
                  path ? `${path}.conditions.${index}.` : `conditions.${index}`
                }
                group={condition}
                onAddCondition={onAddCondition}
                onChange={onChange}
                rootGroup={rootGroup}
                fieldTemplates={fieldTemplates}
                patientFields={patientFields}
                formTemplateTypes={formTemplateTypes}
                disabled={disabled}
              />
              {index !== conditions.length - 1 && (
                <LogicalOperators
                  key={`${path}.conditions[${index}].operation`}
                  value={condition.operation}
                  onChange={operator => {
                    const newRootCondition = produce(rootGroup, draft => {
                      set(draft, `conditions.${index}.operation`, operator);
                    });
                    onChange(newRootCondition);
                  }}
                  disabled={disabled}
                />
              )}
            </Box>
          );
        }
        if ('reference' in condition) {
          return (
            <ConditionRow
              key={`${path}.conditions[${index}].condition`}
              condition={condition}
              onChange={onChange}
              path={`${path}.conditions.${index}`}
              rootGroup={rootGroup}
              fieldTemplates={fieldTemplates}
              patientFields={patientFields}
              formTemplateTypes={formTemplateTypes}
              disabled={disabled}
            />
          );
          // <Box display={'flex'} justifyContent={'end'} width={'100%'}>
          //   <Button onClick={() => onAddCondition(path ?? '')}>
          //     <Add /> {t('dialogs.addField.addCondition')}
          //   </Button>
          // </Box>
        }
        return null;
      })}
    </>
  );
}
